module.exports = __webpack_public_path__ + "img/helm_of_iron_will.1f0c5482.png";